
document.addEventListener("DOMContentLoaded", () => {

    let options = {
        rootMargin: "0px",
        threshold: 0.75
    };

    const renderIndicators = (container) => {

        const indicators = [...container.querySelectorAll('.timeline__indicators li')];
        const indicatorList = container.querySelector('.timeline__indicators ul');
        const btnNext = container.querySelector('.btnNext');
        const btnPrevious = container.querySelector('.btnPrevious');

        const sections = [...container.querySelectorAll(".timeline > li")];

        indicators.forEach((indicator, index) => {

            const currentIndex = sections.findIndex((s) =>
                s.classList.contains("fadeIn")
            );

            if (currentIndex < 0) {
                return;
            }

            if (index === currentIndex) {
                indicator.classList.add("active");

            } else {
                indicator.classList.remove("active");
            }

            if (currentIndex < 1) {
                btnPrevious.style.visibility = 'hidden';
            } else {
                btnPrevious.style.visibility = 'revert';
            }

            if (currentIndex + 1 === indicators.length) {
                btnNext.style.visibility = 'hidden';
            } else {
                btnNext.style.visibility = 'revert';
            };

            btnPrevious.addEventListener("click", (e) => {
                const previousElementSibling = sections[currentIndex].previousElementSibling;
                if (previousElementSibling) {
                    previousElementSibling.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                        inline: "nearest",
                    });
                }
            });

            btnNext.addEventListener("click", (e) => {
                const nextElementSibling = sections[currentIndex].nextElementSibling;
                if (nextElementSibling) {
                    nextElementSibling.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                        inline: "nearest",
                    });
                }
            });

            indicatorList.style.setProperty('--x', `-${currentIndex * 84}px`);
        });

    };

    const callback = (entries, observer) => {

        const { target } = entries[0];

        const container = target.closest('[aria-label="timeline"]');

        entries.forEach(entry => {

            const { target } = entry;

            if (entry.isIntersecting) {
                // fade in observed elements that are in view
                entry.target.classList.replace('fadeOut', 'fadeIn');
            } else {
                // fade out observed elements that are not in view
                entry.target.classList.replace('fadeIn', 'fadeOut');
            }
        });

        renderIndicators(container);
    };

    const observer = new IntersectionObserver(callback, options);

    const timelineContainers = [...document.querySelectorAll('[aria-label="timeline"')];

    timelineContainers.forEach((container, index) => {
        const sections = [...container.querySelectorAll("li")];
        sections.forEach((section, index) => {
            observer.observe(section);
        });
    });
});